// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"login_loginWrapper__xa6DS","title":"login_title__6T8zf","lead":"login_lead__Eqda3","button":"login_button__MiOvx"};